module.exports = "<audio controls #player=\"\" (ended)=\"playerEnded()\" controlsList=\"nodownload\"> "